<template>
  <div class="page-container">
    <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item>gas</el-breadcrumb-item>
    </el-breadcrumb> -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">gas和阈值管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>gas</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <!-- <el-select
          :value="queryType"
          @change="setQueryType"
          placeholder="请选择账户类型"
        >
          <el-option
            v-for="item in queryTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <el-input placeholder="请输入币种名称" clearable v-model="queryValue">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <!-- <el-select v-model="userStatus" placeholder="请选择用户状态">
          <el-option>请选择</el-option>
          <el-option
            v-for="item in status"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <!-- <el-select v-model="userType" placeholder="请选择股东级别">
          <el-option>请选择</el-option>
          <el-option
            v-for="item in Shareholder"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >isFinished
          </el-option>
        </el-select> -->
        <!-- <el-select v-model="isFinished" placeholder="请筛选完成状态" clearable>
          <el-option>全部</el-option>
          <el-option
            v-for="item in isFinishedOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <!-- <el-select v-model="mark" placeholder="请筛选内部状态" clearable>
          <el-option>全部</el-option>
          <el-option
            v-for="item in innerStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </div>
      <user-list @refresh="refreshList" :queryValue="queryValue"></user-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import UserList from './components/list';
import { mapState, mapActions, mapMutations } from 'vuex';
import { QUERY_TYPE, PAGINATION } from './constants';

export default {
  name: 'BlockInfo',
  components: {
    UserList
  },
  data() {
    return {
      seletData:{},
      queryValue: '',
      userStatus: '',
      userType: '',
      mark: '',
      isFinished:'',
      status: [{ value: 0, label: '激活' }, { value: '-1', label: '冻结' }],
      isFinishedOption: [{ value: true, label: '完成' }, { value: false, label: '未完成' }],
      Shareholder: [
        { value: '1', label: '无效用户' },
        { value: '2', label: '普通用户' },
        { value: '3', label: '初级股东' },
        { value: '4', label: '中级股东' },
        { value: '5', label: '高级股东' }
      ],
      ifMark: [
        { value: true, label: '异常账户' },
        { value: false, label: '非异常账户' }
      ],
      innerStatus:[
        { value: 'SUCCESS', label: '成功' },
        { value: 'FAIL', label: '失败' },
        { value: 'EXECUTING_DISPOSE', label: '正在执行中' },
        { value: 'FAIL_CANNOT_RETRY ', label: '失败不能重试' },
        { value: 'REPEAT_CANNOT_RETRY', label: '重复不能重试' },
        { value: 'UNSUPPORTED_TRANSACTION', label: '不支持此交易' },
        { value: 'WAITING_FOR_CONFIRMATION', label: '等待确认中' },
      ]
    };
  },
  computed: {
    ...mapState('gas', ['queryType', 'queryTypeList', 'pagination'])
  },
  methods: {
    ...mapActions('gas', ['list','getGasList']),
    // ...mapMutations('gas', ['setQueryType']),
    refreshList(data = {}) {
      this.getGasList({coin:this.queryValue,...data})
    },
    handleSearch() {
    
      this.getGasList({page:1,size:25,coin:this.queryValue,})
    }
  },
  created() {
    // this.getBlockInfoList({
    //   isFinished:'',
    //   disposeStatusInner:'',
    //   ...PAGINATION
    // });
    this.getGasList({page:1,size:25,coin:this.queryValue})
  }
};
</script>

<style lang="less" scoped>
  .page-actions{
    margin-bottom: 10px;
  }
</style>
